import { HTTPError, HTTPStatusCode, sanitizeError } from '@gitbook/util-debug';

export function getDuplicateSpaceError(error: unknown): string {
    if (error instanceof HTTPError && error.expose) {
        switch (error.statusCode) {
            case HTTPStatusCode.Locked:
                return 'An ongoing task is stopping the space from being duplicated. Wait a moment.';
            case HTTPStatusCode.Unauthorized:
                return 'Your account does not have permission to duplicate this space.';
        }
    }

    if (error instanceof Error) {
        return sanitizeError(error, 'Something went wrong while duplicating the space.');
    }

    return 'Something went wrong while duplicating the space.';
}
